import * as React from 'react'
import { Drawer, Tag, Select, Badge } from 'antd'
import { SellableProductAsyncInput } from '../../../components/ProductAsyncInput/SellableProductAsyncInput'
import { IBaseProduct, ProductLogEventType } from '@getgreenline/homi-shared'
import { ProductLog } from './AddProduct/ProductLog'

interface Props {
  companyId: number
  visible: boolean
  onClose: () => void
}

interface State {
  product?: IBaseProduct
  selectedEventType?: ProductLogEventType
}

export class ProductLogDrawer extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {}
  }

  render() {
    const { companyId } = this.props
    const { product, selectedEventType } = this.state

    return (
      <Drawer
        title='Product edit history'
        width={500}
        visible={this.props.visible}
        onClose={this.props.onClose}
      >
        <div className='mb-2'>
          {product ? (
            <Tag closable onClose={() => this.setState({ product: undefined })}>
              {product.parentProductName
                ? `${product.parentProductName} - ${product.name}`
                : product.name}
            </Tag>
          ) : (
            <SellableProductAsyncInput
              clearable
              placeholder='Search by SKU or name'
              onSelect={(product) => {
                this.setState({ product })
              }}
              onEmptySelect={() => {
                this.setState({ product: undefined })
              }}
            />
          )}
        </div>
        <div>
          <Select<ProductLogEventType | undefined>
            value={selectedEventType}
            onChange={(e) => this.setState({ selectedEventType: e })}
            style={{ width: 150 }}
            placeholder='All types'
            allowClear
          >
            <Select.Option value='create'>
              <Badge status='success' style={{ marginRight: 5 }} />
              Create
            </Select.Option>
            <Select.Option value='update'>
              <Badge color='blue' style={{ marginRight: 5 }} />
              Update
            </Select.Option>
            <Select.Option value='delete'>
              <Badge status='error' style={{ marginRight: 5 }} />
              Delete
            </Select.Option>
          </Select>
        </div>
        <br />
        <ProductLog
          companyId={companyId}
          productId={product ? product.id : undefined}
          eventType={selectedEventType}
          defaultLimit={50}
        />
      </Drawer>
    )
  }
}
